import { useAnalytics } from "@hooks/useAnalytics";
import { type ComponentProps, type FromSanityGraphQL } from "@ts/components";
import { type SectionSellingPoints } from "@ts/sanity";
import React, { useCallback, type FC } from "react";

type SellingPointsInputProps = ComponentProps &
  FromSanityGraphQL<SectionSellingPoints>;

export type SellingPointsOutputProps = SellingPointsInputProps;

export const withSellingPoints =
  (Component: FC<SellingPointsOutputProps>) =>
  ({ name = "SellingPoints", analytics, ...rest }: SellingPointsInputProps) => {
    const { trackPromoImpression, VisibilitySensor } = useAnalytics();
    Component.displayName = name;

    const handleVisibilityChange = useCallback(() => {
      if (!analytics) {
        return;
      }

      trackPromoImpression(analytics);
    }, [analytics]);

    return (
      <VisibilitySensor onChange={handleVisibilityChange}>
        <Component {...rest} />
      </VisibilitySensor>
    );
  };
